export enum AdType {
    BANNER = 'banner',
    INTERSTITIAL = 'interstitial',
    REWARDED = 'rewarded',
}

export const AdPlacements = {
    BANNER: 'banner',
    INTERSTITIAL: 'interstitial',
} as const;

export type AdPlacement = typeof AdPlacements[keyof typeof AdPlacements];

export type AdActivityType = 'book' | 'game' | 'learn' | 'topic';
export type InterstitialContextType = 'call' | 'explore';
export type InterstitialTriggerSource = 'activityEnter' | 'activityExit' | 'bookPage' | 'activityCompleted';
export type InterstitialFailureReason =
    | 'noInventory'
    | 'notReady'
    | 'unknown';

export interface InterstitialPlacementContext {
    callId?: string;
    activityId: string;
    activityTitle: string;
    activityType: AdActivityType;
    context: InterstitialContextType;
    triggerSource: InterstitialTriggerSource;
    pageNumber?: number;
}

export interface InterstitialFailure {
    failureReason: InterstitialFailureReason;
    placeholderShown: boolean;
    providerErrorMessage?: string;
}

export interface AdsProvider {
    init(): Promise<void>;

    showBanner(placementId: string, containerId: string): Promise<void>;
    hideBanner(): Promise<void>;
    setBannerPlaceholderDisplayedListener?(listener?: () => void): void;
    setBannerPlaceholderVisibilityListener?(listener?: (containerId: string, isVisible: boolean) => void): void;
    setInterstitialPlaceholderDisplayedListener?(listener?: () => void): void;
    setInterstitialPlaceholderClickListener?(listener?: () => void): void;
    setInterstitialDismissedListener?(listener?: (placementId: string) => void): void;
    setInterstitialShownListener?(listener?: (placementId: string, provider: string) => void): void;
    setInterstitialShowFailedListener?(
        listener?: (placementId: string, failure: InterstitialFailure) => void,
    ): void;
    setForcePlaceholderAdsEnabled?(enabled: boolean): void;
    resumeBanner?(): Promise<void>;
    destroyBanner?(): Promise<void>;
    shouldResumeBannerAfterModal?(): boolean;
    setModalOpenState?(isOpen: boolean): void;

    supportsInterstitial(): boolean;
    preloadInterstitial?(placementId: string): Promise<void>;
    showInterstitial?(placementId: string): Promise<void>;

    supportsRewarded(): boolean;
    preloadRewarded?(): Promise<void>;
    showRewarded?(onReward: () => void): Promise<void>;
}
